// extracted by mini-css-extract-plugin
module.exports = {"centered":"CreateAccountSuccessModal__centered___1b-b2","plane":"CreateAccountSuccessModal__plane___3DhcC","body":"CreateAccountSuccessModal__body___PpbAu"};